import { buildAction, dispatch } from "./iframeHelpers";

/**
 * These helpers are used to keep the state of the iframe app in sync
 * with web-authentication to satisfy various requirements like
 * different titles depending on form state and hiding UI elements
 */
export const OTP_FORM_ACTIONS = {
  // eslint-disable-next-line sonarjs/no-hardcoded-passwords -- false positive
  SHOW_EMAIL_PASSWORD_SIGNUP: "SHOW_EMAIL_PASSWORD_SIGNUP",
  // eslint-disable-next-line sonarjs/no-hardcoded-passwords -- false positive
  SHOW_EMAIL_AND_PASSWORD_STEP: "SHOW_EMAIL_AND_PASSWORD_STEP",
  SHOW_OTP_EMAIL_CONFIRM_STEP: "SHOW_OTP_EMAIL_CONFIRM_STEP",
  SHOW_OTP_EMAIL_LOGIN_STEP: "SHOW_OTP_EMAIL_LOGIN_STEP",
  SHOW_OTP_PHONE_CONFIRM_STEP: "SHOW_OTP_PHONE_CONFIRM_STEP",
  SHOW_OTP_PHONE_LOGIN_STEP: "SHOW_OTP_PHONE_LOGIN_STEP",
} as const;

/**
 * Message sent after cancel login with email and password button is clicked
 * iframe consumer switches the iframe app src when dispatch message is received
 * {@link https://github.com/turo/web-authentication/blob/ed881865d75f2f813efddfa61183c5f0dfb41b7f/src/useAuthentication.ts#L884-L887}
 */
export const onShowOtpPhoneLoginStep = () =>
  dispatch(buildAction(OTP_FORM_ACTIONS.SHOW_OTP_PHONE_LOGIN_STEP)());

export const onShowOtpPhoneConfirmStep = () =>
  dispatch(buildAction(OTP_FORM_ACTIONS.SHOW_OTP_PHONE_CONFIRM_STEP)());

export const onShowEmailAndPasswordStep = () =>
  dispatch(buildAction(OTP_FORM_ACTIONS.SHOW_EMAIL_AND_PASSWORD_STEP)());

export const onShowOtpEmailLoginStep = () =>
  dispatch(buildAction(OTP_FORM_ACTIONS.SHOW_OTP_EMAIL_LOGIN_STEP)());

export const onShowOtpEmailConfirmStep = () =>
  dispatch(buildAction(OTP_FORM_ACTIONS.SHOW_OTP_EMAIL_CONFIRM_STEP)());

export const onShowSignupFormStep = () =>
  dispatch(buildAction(OTP_FORM_ACTIONS.SHOW_EMAIL_PASSWORD_SIGNUP)());
